<template>
  <div
    class="c--referral_hero-banner referral-hero-banner tw-flex tw-justify-center tw-relative tw-bg-contain tw-overflow-hidden"
  >
    <nuxt-img
      src="/assets/images/referral/hero-header-banner-referral.svg"
      width="1440"
      height="400"
      alt="referral-hero-banner"
      loading="eager"
      class="tw-object-contain tw-max-w-full tw-h-auto min-[1110px]:tw-h-[400px]"
    />
  </div>
</template>

<script>
  export default {
    name: 'referral-hero-banner',
  }
</script>

<style lang="scss" scoped>
  .referral-hero-banner {
    background: linear-gradient(to bottom, #a3ebef, #fcf3e6) no-repeat center;
  }
</style>
